<template>
  <div>
    <div class="header">
      <div class="session-id">
        <div class="iconBox">
          <v-icon>mdi-lightning-bolt</v-icon>
        </div>
        <div>
          <div class="title">
            Session #{{ selectedRow?.id }}
          </div>
          <div class="sub-title">
            {{ selectedRow?.charge_point_id }}/{{ selectedRow?.connector_id }}
          </div>
        </div>
      </div>
      <div>
        <!-- <v-btn
          color="gray"
          outlined
          class="mx-2"
        >
          Export
        </v-btn> -->
        <download-file-buttons
          v-if="downloadOpt.length > 0"
          :small="false"
          :items="downloadOpt"
          @click="downloadFileOf"
        />
      </div>
    </div>
    <div class="">
      <billing-tab
        :ref="'billing'"
        :item="selectedRow"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    DownloadFileButtons: () =>
      import("@/components/base/DownloadFileButtons.vue"),
    BillingTab: () => import("../../charging-sessions/utils/BillingTab.vue"),
  },
  props: {
    selectedRow: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tab: null,

      pdfLogo: require("@/assets/brandLogo/pdfLogo.png"),
    };
  },
  computed: {
    ...mapGetters({
      isEnergy: "csmsChargingSession/getLoading",
      energyData: "csmsChargingSession/getEnergyData",
    }),
    downloadOpt() {
      return ["csv", "excel", "pdf"];
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const params = {
        id: this.selectedRow?.id,
      };
      await this.$store.dispatch("csmsChargingSession/energyData", params);
    },
    downloadFileOf(v) {
      let { downloadFile } = this.$refs["billing"];
      downloadFile(v);
    },
  },
};
</script>
<style lang="sass" scoped>
.header
  margin-bottom: 1rem
  display: flex
  justify-content: space-between
  align-items: baseline
  .session-id
    display: flex
    align-items: center
    gap: 1rem
    .iconBox
      background: #dcdcdc
      padding: 1rem
      border-radius: 100%
    .title
      font-size: 20px !important
      font-weight: 600 !important
</style>
